import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const ArrowRight = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="ArrowRight" {...rest}>
      <path
        d="M15.49 5l7.01 7.011-7.01 7.01M22 12.021H0"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SvgIcon>
  );
};
